import React from 'react'
import Carousel from '@/Carousel'
import ParagraphWithTitle from '@/ParagraphWithTitle'
import SectionContainer from '@/Section/Container'

import {
  StyledContentWithSliderContent,
  StyledContentWithSliderCarousel
} from './styles'

const ContentWithSlider = ({
  sectionGeneral: { theme },
  sectionHeader,
  sectionContent,
}) => {
  const {
    description,
    title,
  } = sectionHeader
  const {
    slides,
    textDisposition,
    objectFit,
    TextContentModal,
  } = sectionContent

  return (
    <SectionContainer theme={theme}>
      <StyledContentWithSliderContent disposition={textDisposition}>
        {
          <ParagraphWithTitle
            maxLines={8}
            description={description}
            title={title}
            textContentModal={TextContentModal}
          />
        }

        <StyledContentWithSliderCarousel>
          <Carousel slides={slides} objectFit={objectFit} />
        </StyledContentWithSliderCarousel>

      </StyledContentWithSliderContent>
    </SectionContainer>
  )
}

export default ContentWithSlider
